var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { position, top, left, right, width, height, backgroundColor, boxShadow, themeGet, } from 'styled-system';
import { themeWidth } from '../theme/theme';
var DrawerContainer = styled.section(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  overflow-y: auto;\n  transition-property: transform;\n  transition-duration: 0.16s;\n  transition-timing-function: ", ";\n  transform: ", ";\n  z-index: 2000;\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  overflow-y: auto;\n  transition-property: transform;\n  transition-duration: 0.16s;\n  transition-timing-function: ",
    ";\n  transform: ",
    ";\n  z-index: 2000;\n  ",
    ";\n"])), position, top, right, themeWidth, height, backgroundColor, boxShadow, function (props) {
    return props.isOpen ? 'ease-out' : 'ease-in';
}, function (props) {
    return props.isOpen
        ? 'transform: translate3d(0, 0, 0)'
        : props.isSideNav
            ? 'translate3d(-336px, 0, 0)'
            : 'translate3d(100%, 0, 0)';
}, function (props) {
    return props.isSideNav && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      left: 0;\n      min-width: ", "px;\n      max-width: ", "px;\n      box-shadow: 0 0 4px 0 rgba(44, 54, 56, 0.3);\n    "], ["\n      left: 0;\n      min-width: ", "px;\n      max-width: ", "px;\n      box-shadow: 0 0 4px 0 rgba(44, 54, 56, 0.3);\n    "])), themeGet('space.11')(props), themeGet('space.12')(props));
});
DrawerContainer.defaultProps = {
    position: 'fixed',
    top: 0,
    right: 0,
    themeWidth: ['100%', '55%', null, '25%'],
    height: '100%',
    backgroundColor: 'white',
    boxShadow: '-4px 2px 6px 0 rgba(0, 0, 0, 0.15)',
};
var DrawerBackdrop = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  transition-property: background-color;\n  transition-duration: 0.16s;\n  transition-timing-function: linear;\n  z-index: 1999;\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  transition-property: background-color;\n  transition-duration: 0.16s;\n  transition-timing-function: linear;\n  z-index: 1999;\n  ",
    ";\n"])), position, top, left, width, height, function (props) {
    return props.isOpen
        ? css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n          pointer-events: auto;\n          background-color: ", ";\n        "], ["\n          pointer-events: auto;\n          background-color: ", ";\n        "])), themeGet('colors.darker-overlay')(props)) : css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n          pointer-events: none;\n          background-color: rgba(0, 0, 0, 0);\n        "], ["\n          pointer-events: none;\n          background-color: rgba(0, 0, 0, 0);\n        "])));
});
DrawerBackdrop.defaultProps = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: 1,
    height: '100%',
    backgroundColor: 'overlay',
};
var Drawer = function (_a) {
    var isOpen = _a.isOpen, isSideNav = _a.isSideNav, children = _a.children, onBackdropClick = _a.onBackdropClick;
    return (React.createElement(Fragment, null,
        React.createElement(DrawerContainer, { isOpen: isOpen, isSideNav: isSideNav, "aria-hidden": !isOpen, "data-testid": "drawer-container" }, children),
        React.createElement(DrawerBackdrop, { isOpen: isOpen, onClick: onBackdropClick, "aria-hidden": !isOpen, "data-testid": "drawer-backdrop" })));
};
Drawer.propTypes = {
    /** Should drawer be visible (default: false) */
    isOpen: PropTypes.bool,
    /** Drawer content */
    children: PropTypes.node,
    /** Event callback that is triggered when backdrop is clicked */
    onBackdropClick: PropTypes.func,
    /** Should be the sideNav drawer (default: false) */
    isSideNav: PropTypes.bool,
};
Drawer.defaultProps = {
    isOpen: false,
    isSideNav: false,
};
export default Drawer;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
